module.exports = __webpack_public_path__ + "static/media/magic-link-lock-success.d9c2e41e.svg";